import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23ZM10 9H6V11H7V13H9V11H10V9ZM18 9H14V11H15V13H17V11H18V9ZM12 13C10.1481 13 8.53256 14.0074 7.66955 15.4993L7.16882 16.3649L8.90004 17.3663L9.40076 16.5007C9.92099 15.6014 10.8909 15 12 15C13.1092 15 14.0791 15.6014 14.5993 16.5007L15.1 17.3663L16.8312 16.3649L16.3305 15.4993C15.4675 14.0074 13.852 13 12 13Z"}}]};

const DespiseFilled = Vue.extend<IconProps>({
  name: 'DespiseFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'despise-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default DespiseFilled;
